import { memo } from 'react';
import React from 'react';
import moment from 'moment';
import {
 TableHead,
 TableRow,
 TableBody,
 TableAccruals,
} from '../MeteringDevices.styled';

const MeteringHistoryData = (data: any) => {
 const accruals = data?.data;

 if (!accruals || (accruals && accruals.length === 0)) {
  return null;
 }

 return (
  <TableAccruals>
   <TableHead>
    <TableRow>
     <th scope="col">Дата показаний</th>
     <th scope="col">Шкала</th>
     <th scope="col">Показания</th>
     <th scope="col">Расход</th>
     <th scope="col">Источник приема показаний</th>
    </TableRow>
   </TableHead>
   {accruals?.map((accruals, index) => {
    return (
     <TableBody key={index}>
      <>
       <TableRow key={index}>
        <td>{moment(accruals?.dataValue).format('DD.MM.YYYY')}</td>
        <td>
         {accruals?.values.map((val) => {
          return <div>{val.name}</div>;
         })}
        </td>
        <td>
         {accruals?.values.map((val) => {
          return <div>{val.value}</div>;
         })}
        </td>

        <td>
         {accruals?.values.map((val) => {
          return <div>{val.consumption}</div>;
         })}
        </td>

        <td>
         {accruals?.values.map((val) => {
          return <div>{val.sourceValue}</div>;
         })}
        </td>
       </TableRow>
      </>
     </TableBody>
    );
   })}
  </TableAccruals>
 );
};

export default memo(MeteringHistoryData);
